import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d0de0c5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "issue-strategy-wrap" }
const _hoisted_2 = { class: "message-push" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagePush = _resolveComponent("MessagePush")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MessagePush, {
        "device-id": _ctx.deviceId,
        "is-terminal-info": ""
      }, null, 8, ["device-id"])
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}